import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
import { StatBlockGrid } from '@bechtel/client-dashboard-common';

export const FEDashboardContentStyled = styled(Box).attrs({
  py: { sm: '500' },
  flexDirection: { sm: 'column' },
})`
  height: 100%;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.colors.grey[100]};
`;

export const FEDashboardStatStyled = styled(Box).attrs({ px: { sm: '600' } })`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacings[600]};
    & > :not(:last-child) {
      margin-right: ${theme.spacings[600]};
    }
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      margin-bottom: ${theme.spacings[500]};
      & > :not(:last-child) {
        margin-right: ${theme.spacings[500]};
      }
    }
    @media only screen and (max-width: ${theme.breakpoints.desktop}) {
      & > :not(:last-child) {
        margin-right: ${theme.spacings[400]};
      }
    }
  `}
`;

export const SectionListStyled = styled(Box).attrs({ pb: { sm: '300' }, px: { sm: '600' } })`
  overflow-y: auto;
  height: 100vh;
`;

export const DashBoardLeftSectionStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: 100%;
`;

export const StatBlockGridFEStyled = styled(StatBlockGrid)`
  flex: 1 1 0;
`;

export const WorkPackageContainerStyled = styled(Box)`
  margin-right: ${({ theme }) => theme.spacings[600]};
  width: 32.8%;
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    margin-right: ${({ theme }) => theme.spacings[500]};
  }
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 40%;
    margin-right: ${({ theme }) => theme.spacings[400]};
  }
`;

export const PendingApprovalListContainerStyled = styled(Box)`
  width: 67.2%;
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 60%;
  }
`;
